module.exports = __webpack_public_path__ + "static/img/case_banner_15.fb9742c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_banner_15.png
// module id = 288T
// module chunks = 34